<ng-container [ngSwitch]="formMode">
  <ng-container *ngSwitchCase="'memo'">
    <div
      *ngIf="isRefreshing"
      [style.height.px]="575"
    ></div>
    <div
      class="form-group mt-0"
      style="overflow: hidden"
    >
      <label class="">{{ 'MEMOS.DETAIL' | translate }} </label>
      <editor
        *ngIf="!isRefreshing"
        class="zoom-editor"
        [(ngModel)]="memoData[this.inputComponent.controlName]"
        (ngModelChange)="editorChange()"
        [init]="config"
      >
      </editor>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'normal'">
    <div
      *ngIf="isRefreshing"
      [style.height.px]="375"
    ></div>
    <editor
      *ngIf="!isRefreshing"
      class="zoom-editor editor"
      [formControl]="control"
      (onSetContent)="onSetContent($event)"
      [init]="configEditorMail"
    >
    </editor>
    <span
      *ngIf="!isRefreshing"
      class="remain"
      [class.text-asterisk]="remain < 0"
    >
      {{ 'EMAIL-SETTING.CHAR-REMAIN' | translate }}: {{ remain }}
    </span>
  </ng-container>

  <ng-container *ngSwitchCase="'contract_tc'">
    <div
      *ngIf="isRefreshing"
      [style.height.px]="375"
    ></div>
    <editor
      *ngIf="!isRefreshing"
      class="zoom-editor editor"
      [formControl]="control"
      (onSetContent)="onSetContent($event)"
      [init]="configContractTC"
    >
    </editor>
  </ng-container>
</ng-container>
